export const COLOR_SCHEME = {
  keyColor: '#ff6f93',
  // second: '#00ff00',
  // gradStart: '#537fe4',
  // gradEnd: '#5beae8',
  baseBg: '#ff6f93', // ヘッダ用のBGとして使用(指定がない場合はgradStart,gradEndを使用し標準パラメータでグラデーションを描画)
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/MarkLp/Kurenotori/Lp1/basicInfos.js